import { render, staticRenderFns } from "./diveCommentPopup.vue?vue&type=template&id=3cfbab7e&scoped=true&"
import script from "./diveCommentPopup.vue?vue&type=script&lang=js&"
export * from "./diveCommentPopup.vue?vue&type=script&lang=js&"
import style0 from "./diveCommentPopup.vue?vue&type=style&index=0&id=3cfbab7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfbab7e",
  null
  
)

export default component.exports